<div class="row p-2 mb-3 align-items-center">
  <div class="col-12 col-md-7 text-start">
    <div class="page-title-heading">
      <div class="page-title-icon"><i class="fa-solid fa-user-shield"></i></div>
      <div>
        Rôles
        <div class="page-title-subheading">Rôles applicatifs</div>
      </div>
    </div>
  </div>
  <div class="col-12 col-md-5 text-end">
    <app-header></app-header>
  </div>
</div>
    <div class="row">
      <div class="main-card mb-3 card">
        <div class="card-body">
          <div class="d-flex justify-content-between mb-2">
<div class="me-2">
                        <button type="button" class="btn btn-danger btn-sm" (click)="add(contentAdd)">
        <i class="fa-solid fa-plus me-2" aria-hidden="true"></i>Nouveau rôle
      </button>
                    </div>
                                <div class=" " >
                <button  (click)="edit(contentEdit)" type="button"  class="btn btn-outline-warning btn-sm btn-label waves-effect waves-light me-3">
                  Editer</button>
                <button  (click)="delete()" type="button" class="btn btn-outline-danger btn-sm btn-label waves-effect waves-light me-3">
                     Supprimer</button>
                     <button class="btn btn-primary btn-sm btn-label waves-effect waves-light  me-3" (click)="add(contentCopy)">Copier</button>

                     <button  (click)="goToWindows()" type="button" class="btn btn-outline-info btn-sm btn-label waves-effect waves-light me-3">
                      Configurer les interfaces</button>
                      <button class="btn btn-info btn-sm btn-label waves-effect waves-light  me-3" (click)="openMenu(contentMenu)">Voir le menu</button>

            </div>

         
        
                    <div class="form-group ms-auto">
                        <label for="search_text" class="form-label mb-0"><strong>Rechercher</strong></label>
                        <input id="search_text" type="text" name="search_text" class="form-control form-control-sm"
                               placeholder="Rechercher..." [(ngModel)]="search_text">
                    </div>
                </div>
          <p>{{data!.length}} élément(s)</p>
          <div class="table-responsive">
          <table class="table" >
              <thead class="">
                  <tr>
                      <th style="width: 10px;">#</th>
                      <th>Libellé</th>
                      <th>Fenêtre</th>
                  </tr>
              </thead>
              <tbody>
                  <tr (click)="checked(d)" [class.table-active]="selected_data?.id === d.id" style="cursor: pointer;" *ngFor="let d of data | sampleSearch:search_text:'permissions' | paginate: {
                  id:'ngxP1',
                  itemsPerPage: pg.pageSize,
                  currentPage: pg.p,
                  totalItems: pg.total } ">
                      <td>
                          <div class="form-check mb-2">
                              <input (click)="checked(d)" class="form-check-input" type="radio" [checked]="selected_data?.id === d.id" name="flexRadioDefault">
                          
                          </div>
                      </td>
                      <td>{{d.name}}</td>
                      <td>{{d.windows ? 'Configurée':'Non Configurée'}}</td>
                     
                  </tr>
              
              </tbody>
          </table>
          </div>
            <pagination-controls 
          id="ngxP1"
          (pageChange)="getPage($event)"
        [maxSize]="9"
        [directionLinks]="true"
        [autoHide]="true"
        [responsive]="true"
        [previousLabel]="'Précédent'"
        [nextLabel]="'Suivant'"
        [screenReaderPaginationLabel]="'Pagination'"
        [screenReaderPageLabel]="'page'"
        [screenReaderCurrentLabel]="'Vous êtes sur la page'">
       </pagination-controls>
        </div>
        </div>
      </div>



      <ng-template  #contentAdd let-c="close" let-d="dismiss">
        <form #addForm="ngForm" (ngSubmit)="create(addForm.value)">
          <div class="modal-header">
            <h6 class="modal-title" id="modal-basic-title">Créer un rôle</h6>
            <button type="button" class="btn-close" aria-label="Close" (click)="d('Cross click')"></button>
          </div>
          <div class="modal-body" >
              <div class="row mb-3">
                  <div class="form-group">
                    <label for="">Libellé</label>
                    <input type="text" name="name" ngModel class="form-control">
                  </div>
              </div>
              <div class="container">
                <div class="form-check">
                    <label class="form-check-label me-5" for="flexCheckChecked">
                      Fixer ce rôle ?
                    </label>
                    <input class="form-check-input" type="checkbox" name="canOverwrite" ngModel id="flexCheckChecked">

                  </div>
             </div>
             
          </div>
          <div class="modal-footer">
            <button type="submit" class="btn btn-outline-dark" [disabled]="addForm.invalid" >Sauvegarder <app-loading [isVisible]="loading"></app-loading></button>
          </div>
      </form>
        </ng-template> 

      <ng-template  #contentCopy let-c="close" let-d="dismiss">
        <form #addForm="ngForm" (ngSubmit)="copy(addForm.value)">
          <div class="modal-header">
            <h6 class="modal-title" id="modal-basic-title">Copier un rôle</h6>
            <button type="button" class="btn-close" aria-label="Close" (click)="d('Cross click')"></button>
          </div>
          <div class="modal-body" >
              <div class="row mb-3">
                  <div class="form-group col-12">
                    <label for="">Ancien rôle</label>
                    <ng-select name="old_id" [(ngModel)]="selected_data.id" required disabled>
                      <ng-option *ngFor="let r of data" [value]="r.id">{{r.name}}</ng-option>
                    </ng-select>
                  </div>
                  <div class="form-group col-12">
                    <label for="">Ancien rôle</label>
                    <ng-select name="new_id" ngModel required >
                      <ng-option *ngFor="let r of data" [value]="r.id">{{r.name}}</ng-option>
                    </ng-select>
                  </div>
              </div>
             
          </div>
          <div class="modal-footer">
            <button type="submit" class="btn btn-outline-dark" [disabled]="addForm.invalid" >Faire la copie <app-loading [isVisible]="loading"></app-loading></button>
          </div>
      </form>
        </ng-template> 

        <ng-template  #contentEdit let-c="close" let-d="dismiss">
          <form #addForm="ngForm" (ngSubmit)="update(addForm.value)">
            <div class="modal-header">
              <h6 class="modal-title" id="modal-basic-title">Modifiier un rôle</h6>
              <button type="button" class="btn-close" aria-label="Close" (click)="d('Cross click')"></button>
            </div>
            <div class="modal-body" >
                <div class="row mb-3">
                    <div class="form-group">
                      <label for="">Libellé</label>
                      <input type="text" name="name" [(ngModel)]="selected_data.name" class="form-control">
                    </div>
                   
                  
                </div>
               
            </div>
            <div class="modal-footer">
              <button type="submit" class="btn btn-outline-dark" [disabled]="addForm.invalid" >Sauvegarder <app-loading [isVisible]="loading"></app-loading></button>
            </div>
        </form>
        </ng-template> 


        <ng-template #contentMenu let-offcanvas>
          <div class="offcanvas-header">
            
            <h4 class="offcanvas-title">Visualiseur de menu</h4>
            <button id="closePDFBtn" type="button" class="btn-close" aria-label="Close" (click)="offcanvas.dismiss('Cross click')"></button>
          </div>
          <div class="offcanvas-body">
            <div class="scrollbar-sidebar ag-bg-red " style="overflow: scroll; height: 90vh;">
            
            <div class="app-sidebar__inner">
            <ul class="vertical-nav-menu" >
              <ng-container *ngFor="let m of menu; let i= index">
          
            <li *ngIf="m.status" class="app-sidebar__heading g-text-yellow">{{m.title}}</li>
            <ng-container *ngFor="let e of m.elements; let j= index">
              <li *ngIf="!e.isTitle && !e.hasChildren && e.status">
                <a [routerLink]="e.route" routerLinkActive="mm-active" class="text-white">
                <i class="metismenu-icon fa-solid fa-gear"></i>{{e.name}}
                </a>
                </li>
              <li *ngIf="!e.isTitle && e.hasChildren && e.status" class="">
              <a  data-bs-toggle="collapse" href="#collapseExample{{i}}{{j}}" role="button" aria-expanded="false" attr.aria-controls="collapseExample{{j}}" class="text-white">
              <i class="metismenu-icon fa-solid fa-gear"></i>{{e.name}}
              <i class="metismenu-state-icon fa-solid fa-gear caret-left"></i>
              </a>
              <ul class="collapse" id="collapseExample{{i}}{{j}}">
                <ng-container *ngFor="let sm of e.children"  >
                  <li *ngIf="sm.status">
                    <a  style="color:aliceblue" routerLink="{{sm?.route}}" routerLinkActive="mm-active" class="">
                    <i class="metismenu-icon"></i>{{sm?.name}}
                     </a>
                    </li>
                </ng-container>
             
              </ul>
              </li>
            </ng-container>
           
          </ng-container>
          
            </ul>
            </div>
             
            </div>
          </div>
        </ng-template>